import { agencyScopeRequired, all } from 'core/permissions';

export default {
  view: all('core.view_membership', agencyScopeRequired),
  add: 'core.add_membership',
  change: 'core.change_membership',
  delete: 'core.delete_membership',
  export: 'core.export_membership',
};
